import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {InfoBannerModule} from 'app/departures/departure/info-banner/info-banner.module';
import {DiaryWarningCardComponent} from './diary-warning-card.component';

@NgModule({
  imports: [CommonModule, InfoBannerModule],
  declarations: [DiaryWarningCardComponent],
  exports: [DiaryWarningCardComponent]
})
export class DiaryWarningCardModule {}
